import { currencyLocales } from '@/constants';
import { Locale } from '@/types';
import { useLocale } from 'next-intl';

// format currency
export const usePriceFormat = (value: number) => {
  const locale = useLocale();

  return new Intl.NumberFormat(currencyLocales[locale as Locale], {
    style: 'currency',
    currency: 'EGP',
    currencyDisplay: 'symbol',
    trailingZeroDisplay: 'stripIfInteger',
  })
    .format(value)
    .replace(/(\.|,)00$/g, '');
};

// format percentage
export const usePercentFormat = (value: number) => {
  const locale = useLocale();

  return new Intl.NumberFormat(currencyLocales[locale as Locale], {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value / 100);
};
